import { PlayerPortalsFooter } from '@r-and-a-shared-ui/common-ui';
import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';

import type { PLAYER_PORTALS_MODELS } from '@r-and-a-shared-ui/common-kontent-client';

export default {
  component: () => PlayerPortalsFooter,
  mapEntryToProps: (entry: PLAYER_PORTALS_MODELS.Footer) =>
    kontentAiDataMapping.player_portals_footer(entry),
};
